import { ComponentProps, FC, useEffect, useState } from 'react';
import { PokerVariant } from '../../../../services/table/tableTypes';
import { motion } from 'framer-motion';
import { COLORS } from '../../../../constants/COLORS';

type MixGameRoundLabelProps = {
  round: number;
  roundsPerGame: number;
  currentGameMode: string;
  variants: PokerVariant[];
  showTransition: boolean;
} & ComponentProps<'div'>;

const MixGameRoundLabel: FC<MixGameRoundLabelProps> = ({
  currentGameMode,
  round,
  roundsPerGame,
  variants,
  showTransition,
  className,
}) => {
  showTransition = false;

  const [isCurrentGameVisible, setIsCurrentGameVisible] = useState(true);
  const [isNextGameVisible, setIsNextGameVisible] = useState(false);
  const [currentVariantIndex, setCurrentVariantIndex] = useState(0);
  const [nextVariant, setNextVariant] = useState('');

  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsCurrentGameVisible(false);
  //   }, 2800);
  //   setTimeout(() => {
  //     setIsNextGameVisible(true);
  //   }, 4200);
  // }, []);

  useEffect(() => {
    const currentIndexVariant = variants.findIndex((variant) => {
      return variant.name === currentGameMode;
    });

    if (currentIndexVariant === -1) return;
    if (currentIndexVariant === variants.length - 1) return;

    setCurrentVariantIndex(currentIndexVariant);
    setNextVariant(variants[currentIndexVariant + 1].name);
  }, [currentGameMode, variants]);

  if (showTransition)
    return (
      <div className={className}>
        {isCurrentGameVisible && (
          <div className="flex h-12 min-w-52 flex-col items-center justify-center rounded-md bg-ph-primary-violet px-2.5 py-0.5 text-center">
            <p className="text-xxs font-bold text-white lg:text-xs">{currentGameMode}</p>
            <p className="text-xxs flex justify-center font-bold text-white lg:text-xs">
              {round}/{roundsPerGame}
            </p>
          </div>
        )}

        {!isCurrentGameVisible && !isNextGameVisible && (
          <div className="flex flex-col items-center justify-center">
            <motion.div
              className="flex h-12 w-52 items-center justify-center rounded-md bg-ph-yellow ease-in"
              animate={{
                width: '3em',
                borderRadius: ['0%', '70%', '80%', '100%'],
              }}
              transition={{
                duration: 0.6,
                ease: 'easeInOut',
                times: [0, 0.4, 0.6, 0.8, 1],
              }}
            />
            <motion.div
              className="-mt-[3em] flex h-12 w-12 items-center justify-center rounded-md"
              animate={{
                scale: [1, 1, 1, 1.2, 1],
                width: '13em',
                borderRadius: ['60%', '40%', '20%', '5%'],
                backgroundColor: [COLORS.yellow, COLORS.yellow, COLORS.yellow, COLORS.yellow, COLORS.primaryViolet],
                opacity: [1, 1, 0.9, 1, 1],
              }}
              transition={{
                duration: 0.6,
                ease: 'easeInOut',
                times: [0, 0.6, 0.7, 0.8, 1],
                delay: 0.8,
              }}
            >
              <p className="text-ph-white">{currentVariantIndex + 2}</p>
            </motion.div>
          </div>
        )}

        {isNextGameVisible && (
          <div className="flex h-12 min-w-52 flex-col items-center justify-center rounded-md bg-ph-primary-violet px-2.5 py-0.5 text-center">
            <p className="text-xxs font-bold text-white lg:text-xs">{nextVariant}</p>
            <p className="text-xxs flex justify-center font-bold text-white lg:text-xs">1/{roundsPerGame}</p>
          </div>
        )}
      </div>
    );

  return (
    <span className="rounded-md bg-white bg-opacity-10 px-2.5 py-0.5">
      <p className="text-xxs font-bold text-white text-opacity-50 lg:text-xs">{currentGameMode}</p>
      <p className="text-xxs flex justify-center font-bold text-white text-opacity-50 lg:text-xs">
        {round}/{roundsPerGame}
      </p>
    </span>
  );
};

export default MixGameRoundLabel;
